import React from 'react';
import {Checkbox, Text, WithTooltip} from '@albert-io/atomic';
import type {CheckboxProps} from '@albert-io/atomic/atoms/Checkbox/Checkbox.react';
import './questions-list-header.scss';

interface Props {
  checkboxProps?: CheckboxProps;
  /** Tooltip shown on the checkbox while `checkboxProps.disabled` is set. */
  checkboxDisabledTooltip?: string;
  heading: string;
  selectedQuestionCount: number;
}

const QuestionsListHeader = ({
  checkboxProps,
  checkboxDisabledTooltip,
  heading,
  selectedQuestionCount = 0
}: Props) => {
  const hasSelectedQuestions = selectedQuestionCount > 0;
  return (
    <div className='questions-list-header'>
      {checkboxProps && (
        <WithTooltip
          enabled={!!checkboxProps.disabled && !!checkboxDisabledTooltip}
          content={checkboxDisabledTooltip}
          display='flex'
        >
          <Checkbox {...checkboxProps} size='s' className='questions-list-header__checkbox mr-x2' />
        </WithTooltip>
      )}
      {heading && (
        <Text bold className='questions-list-header__heading' data-testid='questions-list-header'>
          {hasSelectedQuestions ? `${selectedQuestionCount} selected` : heading}
        </Text>
      )}
    </div>
  );
};

export default QuestionsListHeader;
